import { bool, func, node, string } from 'prop-types';
import * as React from 'react';
import cx from 'classnames';
import style from './MenuSublevel.module.scss';

const MenuSublevel = ({ label, disabled, onSelect, className }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={cx(style.button, className)}
      onClick={onSelect}
    >
      {label}
    </button>
  );
};

MenuSublevel.propTypes = {
  label: string.isRequired,
  onSelect: func, // Added by Menu
  children: node.isRequired, // Used by Menu
  showSubLevelLabel: bool, // Used by Menu
  disabled: bool,
};

MenuSublevel.defaultProps = {
  onSelect: undefined,
  disabled: false,
};

export default MenuSublevel;
